import React, { Component } from "react";
import Cookies from "universal-cookie";

import { autotrimitraMasterServices } from "../../services/AutotrimitraMasterServices";
import { Form, Select } from "antd";

const { Option } = Select;

class FilterSelectPartType extends Component {
  cookies = new Cookies();

  initState = {
    dataOption: [],
  };
  state = { ...this.initState };

  componentDidMount = async () => {
    await this.fetchPartTypes();
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.category !== this.props.category) {
      await this.fetchPartTypes();
    }
  };

  fetchPartTypes = async () => {
    try {
      if (this.props.category) {
        const token = this.cookies.get("_t_autotrimitrabiz");
        autotrimitraMasterServices.setToken(token);

        const params = {
          category: this.props.category,
        };

        const response = await autotrimitraMasterServices.getPartTypes(params);
        let listOption = response.data.data.map((d) => {
          return { uuid: d.code, part_type: d.name };
        });
        this.setState({
          dataOption: listOption,
        });
      }
    } catch (error) {
      this.setState({
        dataOption: [],
      });
    }
  };

  render() {
    return (
      <Form.Item label="Part Type" className="col-lg-12">
        <Select
          style={{ fontSize: "85%", minWidth: "200px" }}
          placeholder="Select a Part Type"
          onChange={this.props.onChangeValue}
          value={this.props.value}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0}
          filterSort={(optionA, optionB) => optionA.children?.toLowerCase().localeCompare(optionB.children?.toLowerCase())}
        >
          <Option key="0" value="0">
            ALL
          </Option>
          {this.state.dataOption.map((d, i) => {
            return (
              <Option key={d.part_type} value={d.part_type}>
                {d.part_type}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default FilterSelectPartType;
